import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _528b1e7f = () => interopDefault(import('../pages/frontend/index.vue' /* webpackChunkName: "" */))
const _1aa66aee = () => interopDefault(import('../pages/frontend/applications/index.vue' /* webpackChunkName: "" */))
const _39dd8f38 = () => interopDefault(import('../pages/frontend/calendar/index.vue' /* webpackChunkName: "" */))
const _09efa72c = () => interopDefault(import('../pages/frontend/confirm-redirect.vue' /* webpackChunkName: "" */))
const _64e3dce6 = () => interopDefault(import('../pages/frontend/contact.vue' /* webpackChunkName: "" */))
const _0efb2790 = () => interopDefault(import('../pages/frontend/contact-application.vue' /* webpackChunkName: "" */))
const _027b2eae = () => interopDefault(import('../pages/frontend/contact-complete.vue' /* webpackChunkName: "" */))
const _a08c96a8 = () => interopDefault(import('../pages/frontend/contact-complete-application.vue' /* webpackChunkName: "" */))
const _da6bc67e = () => interopDefault(import('../pages/frontend/dashboard.vue' /* webpackChunkName: "" */))
const _5af71e01 = () => interopDefault(import('../pages/frontend/document/index.vue' /* webpackChunkName: "" */))
const _d06c95a6 = () => interopDefault(import('../pages/frontend/document-templates/index.vue' /* webpackChunkName: "" */))
const _e3daeb8a = () => interopDefault(import('../pages/frontend/function.vue' /* webpackChunkName: "" */))
const _1ec19286 = () => interopDefault(import('../pages/frontend/group-chats/index.vue' /* webpackChunkName: "" */))
const _7f9c77d9 = () => interopDefault(import('../pages/frontend/ls-templates/index.vue' /* webpackChunkName: "" */))
const _24ba1cf5 = () => interopDefault(import('../pages/frontend/privacy.vue' /* webpackChunkName: "" */))
const _eaad5210 = () => interopDefault(import('../pages/frontend/privacy-application.vue' /* webpackChunkName: "" */))
const _15908371 = () => interopDefault(import('../pages/frontend/proposals/index.vue' /* webpackChunkName: "" */))
const _158b0a68 = () => interopDefault(import('../pages/frontend/receipt/index.vue' /* webpackChunkName: "" */))
const _699a96ee = () => interopDefault(import('../pages/frontend/request-group.vue' /* webpackChunkName: "" */))
const _1034805c = () => interopDefault(import('../pages/frontend/resources.vue' /* webpackChunkName: "" */))
const _48f9f804 = () => interopDefault(import('../pages/frontend/resources-complete.vue' /* webpackChunkName: "" */))
const _6a18df09 = () => interopDefault(import('../pages/frontend/settings/index.vue' /* webpackChunkName: "" */))
const _3e315ce9 = () => interopDefault(import('../pages/frontend/templates/index.vue' /* webpackChunkName: "" */))
const _06ee4698 = () => interopDefault(import('../pages/frontend/terms.vue' /* webpackChunkName: "" */))
const _59d91f92 = () => interopDefault(import('../pages/frontend/terms-application.vue' /* webpackChunkName: "" */))
const _5cc90e28 = () => interopDefault(import('../pages/frontend/todo/index.vue' /* webpackChunkName: "" */))
const _a0e563de = () => interopDefault(import('../pages/frontend/trade.vue' /* webpackChunkName: "" */))
const _c8e083d8 = () => interopDefault(import('../pages/frontend/trade-application.vue' /* webpackChunkName: "" */))
const _67fae072 = () => interopDefault(import('../pages/frontend/works/index.vue' /* webpackChunkName: "" */))
const _21143642 = () => interopDefault(import('../pages/frontend/workspace.vue' /* webpackChunkName: "" */))
const _02a18792 = () => interopDefault(import('../pages/frontend/applications/list.vue' /* webpackChunkName: "" */))
const _5574c314 = () => interopDefault(import('../pages/frontend/auth/change-password.vue' /* webpackChunkName: "" */))
const _aa3c6f78 = () => interopDefault(import('../pages/frontend/auth/forgot-password/index.vue' /* webpackChunkName: "" */))
const _32a07bf2 = () => interopDefault(import('../pages/frontend/auth/forgot-password-application/index.vue' /* webpackChunkName: "" */))
const _508e8236 = () => interopDefault(import('../pages/frontend/auth/login.vue' /* webpackChunkName: "" */))
const _9ad6de30 = () => interopDefault(import('../pages/frontend/auth/login-application.vue' /* webpackChunkName: "" */))
const _7bb5bd1a = () => interopDefault(import('../pages/frontend/auth/register/index.vue' /* webpackChunkName: "" */))
const _56bd25dd = () => interopDefault(import('../pages/frontend/auth/register-application/index.vue' /* webpackChunkName: "" */))
const _70f5dc7e = () => interopDefault(import('../pages/frontend/create/document/index.vue' /* webpackChunkName: "" */))
const _639d3a40 = () => interopDefault(import('../pages/frontend/create/first.vue' /* webpackChunkName: "" */))
const _4028b164 = () => interopDefault(import('../pages/frontend/create/form.vue' /* webpackChunkName: "" */))
const _7ab46d1d = () => interopDefault(import('../pages/frontend/create/template/index.vue' /* webpackChunkName: "" */))
const _0c7ffff4 = () => interopDefault(import('../pages/frontend/document-templates/detail.vue' /* webpackChunkName: "" */))
const _40f39764 = () => interopDefault(import('../pages/frontend/document/bulk-upload/index.vue' /* webpackChunkName: "" */))
const _7828ecc2 = () => interopDefault(import('../pages/frontend/document/category.vue' /* webpackChunkName: "" */))
const _0fc18c5a = () => interopDefault(import('../pages/frontend/document/draft/index.vue' /* webpackChunkName: "" */))
const _a0a908ee = () => interopDefault(import('../pages/frontend/document/search.vue' /* webpackChunkName: "" */))
const _636f946e = () => interopDefault(import('../pages/frontend/document/shared/index.vue' /* webpackChunkName: "" */))
const _68f1613c = () => interopDefault(import('../pages/frontend/document/upload.vue' /* webpackChunkName: "" */))
const _2ba36bb8 = () => interopDefault(import('../pages/frontend/lp/allinone.vue' /* webpackChunkName: "" */))
const _610f4894 = () => interopDefault(import('../pages/frontend/lp/create.vue' /* webpackChunkName: "" */))
const _340add9a = () => interopDefault(import('../pages/frontend/lp/document.vue' /* webpackChunkName: "" */))
const _4d2182e2 = () => interopDefault(import('../pages/frontend/lp/document2.vue' /* webpackChunkName: "" */))
const _4d0553e0 = () => interopDefault(import('../pages/frontend/lp/document3.vue' /* webpackChunkName: "" */))
const _4ce924de = () => interopDefault(import('../pages/frontend/lp/document4.vue' /* webpackChunkName: "" */))
const _4cccf5dc = () => interopDefault(import('../pages/frontend/lp/document5.vue' /* webpackChunkName: "" */))
const _4cb0c6da = () => interopDefault(import('../pages/frontend/lp/document6.vue' /* webpackChunkName: "" */))
const _4c9497d8 = () => interopDefault(import('../pages/frontend/lp/document7.vue' /* webpackChunkName: "" */))
const _4c7868d6 = () => interopDefault(import('../pages/frontend/lp/document8.vue' /* webpackChunkName: "" */))
const _3682b5aa = () => interopDefault(import('../pages/frontend/lp/speedy.vue' /* webpackChunkName: "" */))
const _2b010bf9 = () => interopDefault(import('../pages/frontend/proposals/tag.vue' /* webpackChunkName: "" */))
const _82db19cc = () => interopDefault(import('../pages/frontend/settings/calendar/index.vue' /* webpackChunkName: "" */))
const _17f07974 = () => interopDefault(import('../pages/frontend/settings/company.vue' /* webpackChunkName: "" */))
const _461ed78e = () => interopDefault(import('../pages/frontend/settings/group/index.vue' /* webpackChunkName: "" */))
const _e5bf1ef8 = () => interopDefault(import('../pages/frontend/settings/notification.vue' /* webpackChunkName: "" */))
const _4b24fb06 = () => interopDefault(import('../pages/frontend/settings/payment.vue' /* webpackChunkName: "" */))
const _934b967c = () => interopDefault(import('../pages/frontend/settings/plan.vue' /* webpackChunkName: "" */))
const _5597890a = () => interopDefault(import('../pages/frontend/settings/plan-payment.vue' /* webpackChunkName: "" */))
const _4a5440b1 = () => interopDefault(import('../pages/frontend/settings/plan-payment-success.vue' /* webpackChunkName: "" */))
const _236e7df1 = () => interopDefault(import('../pages/frontend/settings/plan-select-user.vue' /* webpackChunkName: "" */))
const _5a6c1fe7 = () => interopDefault(import('../pages/frontend/settings/user/index.vue' /* webpackChunkName: "" */))
const _a0a2ea16 = () => interopDefault(import('../pages/frontend/templates/create.vue' /* webpackChunkName: "" */))
const _ecf0215c = () => interopDefault(import('../pages/frontend/todo/create.vue' /* webpackChunkName: "" */))
const _6c7caf50 = () => interopDefault(import('../pages/frontend/todo/template_detail.vue' /* webpackChunkName: "" */))
const _9af700fe = () => interopDefault(import('../pages/frontend/todo/template_first.vue' /* webpackChunkName: "" */))
const _1ae73246 = () => interopDefault(import('../pages/frontend/todo/template_list.vue' /* webpackChunkName: "" */))
const _c119a7ea = () => interopDefault(import('../pages/frontend/auth/register-application/confirm.vue' /* webpackChunkName: "" */))
const _47d3488b = () => interopDefault(import('../pages/frontend/auth/register/confirm/index.vue' /* webpackChunkName: "" */))
const _600c81e4 = () => interopDefault(import('../pages/frontend/create/document/edit.vue' /* webpackChunkName: "" */))
const _43e71e8f = () => interopDefault(import('../pages/frontend/create/template/edit.vue' /* webpackChunkName: "" */))
const _024ac541 = () => interopDefault(import('../pages/frontend/document/approve/list.vue' /* webpackChunkName: "" */))
const _1461f45c = () => interopDefault(import('../pages/frontend/document/bulk-upload/list.vue' /* webpackChunkName: "" */))
const _7c2de103 = () => interopDefault(import('../pages/frontend/settings/calendar/sync.vue' /* webpackChunkName: "" */))
const _7ca88279 = () => interopDefault(import('../pages/frontend/settings/group/ConfirmChangeRootUserModal.vue' /* webpackChunkName: "" */))
const _2e5384b6 = () => interopDefault(import('../pages/frontend/settings/group/create.vue' /* webpackChunkName: "" */))
const _1098e744 = () => interopDefault(import('../pages/frontend/settings/user/invite.vue' /* webpackChunkName: "" */))
const _9c3aa82e = () => interopDefault(import('../pages/frontend/document/bulk-upload/edit/_id.vue' /* webpackChunkName: "" */))
const _205a7fc4 = () => interopDefault(import('../pages/frontend/settings/group/edit/_id.vue' /* webpackChunkName: "" */))
const _7bf66db0 = () => interopDefault(import('../pages/frontend/settings/user/edit/_id.vue' /* webpackChunkName: "" */))
const _358bd09c = () => interopDefault(import('../pages/frontend/applications/bank-transfer/_app_id.vue' /* webpackChunkName: "" */))
const _1a94bed5 = () => interopDefault(import('../pages/frontend/applications/detail/_id.vue' /* webpackChunkName: "" */))
const _28817434 = () => interopDefault(import('../pages/frontend/applications/form/_app_id.vue' /* webpackChunkName: "" */))
const _1304e1df = () => interopDefault(import('../pages/frontend/auth/change-info/_active_code.vue' /* webpackChunkName: "" */))
const _75101695 = () => interopDefault(import('../pages/frontend/auth/forgot-password-application/_token.vue' /* webpackChunkName: "" */))
const _371ed7f8 = () => interopDefault(import('../pages/frontend/auth/forgot-password/_token.vue' /* webpackChunkName: "" */))
const _fe6d043c = () => interopDefault(import('../pages/frontend/auth/register/_token.vue' /* webpackChunkName: "" */))
const _01deedf9 = () => interopDefault(import('../pages/frontend/auth/verify-email-change-email/_token.vue' /* webpackChunkName: "" */))
const _7111f3ce = () => interopDefault(import('../pages/frontend/auth/verify/_active_code.vue' /* webpackChunkName: "" */))
const _73918cdd = () => interopDefault(import('../pages/frontend/document/approve/_token.vue' /* webpackChunkName: "" */))
const _6c436320 = () => interopDefault(import('../pages/frontend/document/detail/_id/index.vue' /* webpackChunkName: "" */))
const _c870d60a = () => interopDefault(import('../pages/frontend/document/draft/_id.vue' /* webpackChunkName: "" */))
const _aaa2fd54 = () => interopDefault(import('../pages/frontend/document/edit/_id.vue' /* webpackChunkName: "" */))
const _fef3c9da = () => interopDefault(import('../pages/frontend/document/shared/_token.vue' /* webpackChunkName: "" */))
const _09ece385 = () => interopDefault(import('../pages/frontend/ls-templates/detail/_id.vue' /* webpackChunkName: "" */))
const _a3420f0e = () => interopDefault(import('../pages/frontend/ls-templates/use/_id.vue' /* webpackChunkName: "" */))
const _a82fcffa = () => interopDefault(import('../pages/frontend/proposals/clone/_key.vue' /* webpackChunkName: "" */))
const _55af5226 = () => interopDefault(import('../pages/frontend/proposals/detail/_id.vue' /* webpackChunkName: "" */))
const _6b91e5e6 = () => interopDefault(import('../pages/frontend/proposals/edit/_id.vue' /* webpackChunkName: "" */))
const _00a72cea = () => interopDefault(import('../pages/frontend/templates/clone/_key.vue' /* webpackChunkName: "" */))
const _28eca875 = () => interopDefault(import('../pages/frontend/templates/detail/_id.vue' /* webpackChunkName: "" */))
const _61ccf96e = () => interopDefault(import('../pages/frontend/templates/edit/_id.vue' /* webpackChunkName: "" */))
const _1b4ed989 = () => interopDefault(import('../pages/frontend/templates/use/_id.vue' /* webpackChunkName: "" */))
const _695b5130 = () => interopDefault(import('../pages/frontend/todo/clone/_key.vue' /* webpackChunkName: "" */))
const _16dad35c = () => interopDefault(import('../pages/frontend/todo/detail/_id.vue' /* webpackChunkName: "" */))
const _2adeba8b = () => interopDefault(import('../pages/frontend/todo/edit/_id.vue' /* webpackChunkName: "" */))
const _0024b3a2 = () => interopDefault(import('../pages/frontend/works/clone/_key.vue' /* webpackChunkName: "" */))
const _2964f28c = () => interopDefault(import('../pages/frontend/works/detail/_id.vue' /* webpackChunkName: "" */))
const _0e74c25c = () => interopDefault(import('../pages/frontend/works/use/_id.vue' /* webpackChunkName: "" */))
const _31831aac = () => interopDefault(import('../pages/frontend/document/detail/_id/download.vue' /* webpackChunkName: "" */))
const _3341dae6 = () => interopDefault(import('../pages/frontend/document/checkback/_token/_id.vue' /* webpackChunkName: "" */))
const _475426cd = () => interopDefault(import('../pages/frontend/confirm-request/_hash.vue' /* webpackChunkName: "" */))
const _5ead1ed5 = () => interopDefault(import('../pages/frontend/document-templates/_id.vue' /* webpackChunkName: "" */))
const _2107928b = () => interopDefault(import('../pages/frontend/landing/_url.vue' /* webpackChunkName: "" */))
const _6741611c = () => interopDefault(import('../pages/frontend/proposals/_month.vue' /* webpackChunkName: "" */))
const _17284d2b = () => interopDefault(import('../pages/frontend/todo/_status.vue' /* webpackChunkName: "" */))
const _be9dc5d0 = () => interopDefault(import('../pages/admin/index.vue' /* webpackChunkName: "pages/admin/index" */))
const _61d6b950 = () => interopDefault(import('../pages/admin/application_categories/index.vue' /* webpackChunkName: "pages/admin/application_categories/index" */))
const _164da5d5 = () => interopDefault(import('../pages/admin/application_tags/index.vue' /* webpackChunkName: "pages/admin/application_tags/index" */))
const _db5e253e = () => interopDefault(import('../pages/admin/application_view/index.vue' /* webpackChunkName: "pages/admin/application_view/index" */))
const _d77de6e0 = () => interopDefault(import('../pages/admin/applications/index.vue' /* webpackChunkName: "pages/admin/applications/index" */))
const _0aa4ab04 = () => interopDefault(import('../pages/admin/campaign-dashboard/index.vue' /* webpackChunkName: "pages/admin/campaign-dashboard/index" */))
const _0d8b10c9 = () => interopDefault(import('../pages/admin/campaign-statistics/index.vue' /* webpackChunkName: "pages/admin/campaign-statistics/index" */))
const _29b76c64 = () => interopDefault(import('../pages/admin/companies/index.vue' /* webpackChunkName: "pages/admin/companies/index" */))
const _85773680 = () => interopDefault(import('../pages/admin/contacts/index.vue' /* webpackChunkName: "pages/admin/contacts/index" */))
const _f01fd418 = () => interopDefault(import('../pages/admin/document-templates/index.vue' /* webpackChunkName: "pages/admin/document-templates/index" */))
const _04683d1e = () => interopDefault(import('../pages/admin/landing-base.vue' /* webpackChunkName: "pages/admin/landing-base" */))
const _ec22832e = () => interopDefault(import('../pages/admin/landings/index.vue' /* webpackChunkName: "pages/admin/landings/index" */))
const _3f67ef36 = () => interopDefault(import('../pages/admin/meta-groups/index.vue' /* webpackChunkName: "pages/admin/meta-groups/index" */))
const _0d9d58d7 = () => interopDefault(import('../pages/admin/metas/index.vue' /* webpackChunkName: "pages/admin/metas/index" */))
const _17ef75ec = () => interopDefault(import('../pages/admin/option-plan/index.vue' /* webpackChunkName: "pages/admin/option-plan/index" */))
const _0ee7f59a = () => interopDefault(import('../pages/admin/plans/index.vue' /* webpackChunkName: "pages/admin/plans/index" */))
const _d4303102 = () => interopDefault(import('../pages/admin/project-list/index.vue' /* webpackChunkName: "pages/admin/project-list/index" */))
const _c100526c = () => interopDefault(import('../pages/admin/proposals/index.vue' /* webpackChunkName: "pages/admin/proposals/index" */))
const _d575ee6a = () => interopDefault(import('../pages/admin/request-confirm/index.vue' /* webpackChunkName: "pages/admin/request-confirm/index" */))
const _4c360560 = () => interopDefault(import('../pages/admin/request-ebooks/index.vue' /* webpackChunkName: "pages/admin/request-ebooks/index" */))
const _9ab9b636 = () => interopDefault(import('../pages/admin/revenue/index.vue' /* webpackChunkName: "pages/admin/revenue/index" */))
const _13b53c90 = () => interopDefault(import('../pages/admin/settings/index.vue' /* webpackChunkName: "pages/admin/settings/index" */))
const _70c423ef = () => interopDefault(import('../pages/admin/summary/index.vue' /* webpackChunkName: "pages/admin/summary/index" */))
const _66171206 = () => interopDefault(import('../pages/admin/tags/index.vue' /* webpackChunkName: "pages/admin/tags/index" */))
const _6fbe9f7c = () => interopDefault(import('../pages/admin/templates/index.vue' /* webpackChunkName: "pages/admin/templates/index" */))
const _c6e49676 = () => interopDefault(import('../pages/admin/tool/index.vue' /* webpackChunkName: "pages/admin/tool/index" */))
const _e6a906fc = () => interopDefault(import('../pages/admin/types/index.vue' /* webpackChunkName: "pages/admin/types/index" */))
const _808f695e = () => interopDefault(import('../pages/admin/users/index.vue' /* webpackChunkName: "pages/admin/users/index" */))
const _3b341266 = () => interopDefault(import('../pages/admin/application_categories/create.vue' /* webpackChunkName: "pages/admin/application_categories/create" */))
const _49c940ee = () => interopDefault(import('../pages/admin/application_tags/create.vue' /* webpackChunkName: "pages/admin/application_tags/create" */))
const _1b94d02e = () => interopDefault(import('../pages/admin/applications/create.vue' /* webpackChunkName: "pages/admin/applications/create" */))
const _0cb6f7ec = () => interopDefault(import('../pages/admin/auth/login.vue' /* webpackChunkName: "pages/admin/auth/login" */))
const _34ea6ada = () => interopDefault(import('../pages/admin/companies/create.vue' /* webpackChunkName: "pages/admin/companies/create" */))
const _c472196c = () => interopDefault(import('../pages/admin/document-templates/create.vue' /* webpackChunkName: "pages/admin/document-templates/create" */))
const _0f04bb4e = () => interopDefault(import('../pages/admin/document/categories/index.vue' /* webpackChunkName: "pages/admin/document/categories/index" */))
const _48c54d16 = () => interopDefault(import('../pages/admin/landings/create.vue' /* webpackChunkName: "pages/admin/landings/create" */))
const _50e94ef9 = () => interopDefault(import('../pages/admin/meta-groups/create.vue' /* webpackChunkName: "pages/admin/meta-groups/create" */))
const _647be672 = () => interopDefault(import('../pages/admin/metas/create.vue' /* webpackChunkName: "pages/admin/metas/create" */))
const _40a8ebeb = () => interopDefault(import('../pages/admin/plans/create.vue' /* webpackChunkName: "pages/admin/plans/create" */))
const _782f4d34 = () => interopDefault(import('../pages/admin/proposals/create.vue' /* webpackChunkName: "pages/admin/proposals/create" */))
const _b56d451a = () => interopDefault(import('../pages/admin/settings/calendar/index.vue' /* webpackChunkName: "pages/admin/settings/calendar/index" */))
const _f7010d10 = () => interopDefault(import('../pages/admin/tags/create.vue' /* webpackChunkName: "pages/admin/tags/create" */))
const _63a9a2bc = () => interopDefault(import('../pages/admin/templates/create.vue' /* webpackChunkName: "pages/admin/templates/create" */))
const _30785e7c = () => interopDefault(import('../pages/admin/types/create.vue' /* webpackChunkName: "pages/admin/types/create" */))
const _3eeaf385 = () => interopDefault(import('../pages/admin/document/categories/create.vue' /* webpackChunkName: "pages/admin/document/categories/create" */))
const _eabfa922 = () => interopDefault(import('../pages/admin/settings/calendar/oauth2callback.vue' /* webpackChunkName: "pages/admin/settings/calendar/oauth2callback" */))
const _13917dfe = () => interopDefault(import('../pages/admin/document/categories/edit/_id.vue' /* webpackChunkName: "pages/admin/document/categories/edit/_id" */))
const _220e689f = () => interopDefault(import('../pages/admin/application_categories/edit/_id.vue' /* webpackChunkName: "pages/admin/application_categories/edit/_id" */))
const _6556f902 = () => interopDefault(import('../pages/admin/application_tags/edit/_id.vue' /* webpackChunkName: "pages/admin/application_tags/edit/_id" */))
const _fe205852 = () => interopDefault(import('../pages/admin/applications/build/_id.vue' /* webpackChunkName: "pages/admin/applications/build/_id" */))
const _6d36d467 = () => interopDefault(import('../pages/admin/applications/edit/_id.vue' /* webpackChunkName: "pages/admin/applications/edit/_id" */))
const _f0df17da = () => interopDefault(import('../pages/admin/companies/edit/_id.vue' /* webpackChunkName: "pages/admin/companies/edit/_id" */))
const _2b6ca083 = () => interopDefault(import('../pages/admin/document-templates/edit/_id.vue' /* webpackChunkName: "pages/admin/document-templates/edit/_id" */))
const _63926701 = () => interopDefault(import('../pages/admin/document/categories/_id.vue' /* webpackChunkName: "pages/admin/document/categories/_id" */))
const _eb90b48a = () => interopDefault(import('../pages/admin/landings/copy/_target_id.vue' /* webpackChunkName: "pages/admin/landings/copy/_target_id" */))
const _4d4227ee = () => interopDefault(import('../pages/admin/landings/edit/_id.vue' /* webpackChunkName: "pages/admin/landings/edit/_id" */))
const _c132671c = () => interopDefault(import('../pages/admin/meta-groups/edit/_id.vue' /* webpackChunkName: "pages/admin/meta-groups/edit/_id" */))
const _49074ec0 = () => interopDefault(import('../pages/admin/metas/edit/_id.vue' /* webpackChunkName: "pages/admin/metas/edit/_id" */))
const _c49a1638 = () => interopDefault(import('../pages/admin/plans/edit/_id.vue' /* webpackChunkName: "pages/admin/plans/edit/_id" */))
const _afa95b28 = () => interopDefault(import('../pages/admin/plans/new/_id.vue' /* webpackChunkName: "pages/admin/plans/new/_id" */))
const _0d2627ed = () => interopDefault(import('../pages/admin/proposals/edit/_id.vue' /* webpackChunkName: "pages/admin/proposals/edit/_id" */))
const _461c5331 = () => interopDefault(import('../pages/admin/tags/edit/_id.vue' /* webpackChunkName: "pages/admin/tags/edit/_id" */))
const _03613b75 = () => interopDefault(import('../pages/admin/templates/edit/_id.vue' /* webpackChunkName: "pages/admin/templates/edit/_id" */))
const _511ff196 = () => interopDefault(import('../pages/admin/types/edit/_id.vue' /* webpackChunkName: "pages/admin/types/edit/_id" */))
const _79a39bc0 = () => interopDefault(import('../pages/admin/application_categories/_id.vue' /* webpackChunkName: "pages/admin/application_categories/_id" */))
const _b975cd06 = () => interopDefault(import('../pages/admin/application_tags/_id.vue' /* webpackChunkName: "pages/admin/application_tags/_id" */))
const _143d37cc = () => interopDefault(import('../pages/admin/companies/_id.vue' /* webpackChunkName: "pages/admin/companies/_id" */))
const _04249728 = () => interopDefault(import('../pages/admin/contacts/_id.vue' /* webpackChunkName: "pages/admin/contacts/_id" */))
const _8e99f548 = () => interopDefault(import('../pages/admin/document-templates/_id.vue' /* webpackChunkName: "pages/admin/document-templates/_id" */))
const _1989a4ff = () => interopDefault(import('../pages/admin/metas/_id.vue' /* webpackChunkName: "pages/admin/metas/_id" */))
const _2bcffc1c = () => interopDefault(import('../pages/admin/option-plan/_id.vue' /* webpackChunkName: "pages/admin/option-plan/_id" */))
const _75afb85b = () => interopDefault(import('../pages/admin/plans/_id.vue' /* webpackChunkName: "pages/admin/plans/_id" */))
const _761084b2 = () => interopDefault(import('../pages/admin/project-list/_id.vue' /* webpackChunkName: "pages/admin/project-list/_id" */))
const _846df89c = () => interopDefault(import('../pages/admin/proposals/_id.vue' /* webpackChunkName: "pages/admin/proposals/_id" */))
const _0a2dddee = () => interopDefault(import('../pages/admin/tags/_id.vue' /* webpackChunkName: "pages/admin/tags/_id" */))
const _78d2edf9 = () => interopDefault(import('../pages/admin/users/_id.vue' /* webpackChunkName: "pages/admin/users/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _528b1e7f,
    name: "index"
  }, {
    path: "/applications",
    component: _1aa66aee,
    name: "applications"
  }, {
    path: "/calendar",
    component: _39dd8f38,
    name: "calendar"
  }, {
    path: "/confirm-redirect",
    component: _09efa72c,
    name: "confirm-redirect"
  }, {
    path: "/contact",
    component: _64e3dce6,
    name: "contact"
  }, {
    path: "/contact-application",
    component: _0efb2790,
    name: "contact-application"
  }, {
    path: "/contact-complete",
    component: _027b2eae,
    name: "contact-complete"
  }, {
    path: "/contact-complete-application",
    component: _a08c96a8,
    name: "contact-complete-application"
  }, {
    path: "/dashboard",
    component: _da6bc67e,
    name: "dashboard"
  }, {
    path: "/document",
    component: _5af71e01,
    name: "document"
  }, {
    path: "/document-templates",
    component: _d06c95a6,
    name: "document-templates"
  }, {
    path: "/function",
    component: _e3daeb8a,
    name: "function"
  }, {
    path: "/group-chats",
    component: _1ec19286,
    name: "group-chats"
  }, {
    path: "/ls-templates",
    component: _7f9c77d9,
    name: "ls-templates"
  }, {
    path: "/privacy",
    component: _24ba1cf5,
    name: "privacy"
  }, {
    path: "/privacy-application",
    component: _eaad5210,
    name: "privacy-application"
  }, {
    path: "/proposals",
    component: _15908371,
    name: "proposals"
  }, {
    path: "/receipt",
    component: _158b0a68,
    name: "receipt"
  }, {
    path: "/request-group",
    component: _699a96ee,
    name: "request-group"
  }, {
    path: "/resources",
    component: _1034805c,
    name: "resources"
  }, {
    path: "/resources-complete",
    component: _48f9f804,
    name: "resources-complete"
  }, {
    path: "/settings",
    component: _6a18df09,
    name: "settings"
  }, {
    path: "/templates",
    component: _3e315ce9,
    name: "templates"
  }, {
    path: "/terms",
    component: _06ee4698,
    name: "terms"
  }, {
    path: "/terms-application",
    component: _59d91f92,
    name: "terms-application"
  }, {
    path: "/todo",
    component: _5cc90e28,
    name: "todo"
  }, {
    path: "/trade",
    component: _a0e563de,
    name: "trade"
  }, {
    path: "/trade-application",
    component: _c8e083d8,
    name: "trade-application"
  }, {
    path: "/works",
    component: _67fae072,
    name: "works"
  }, {
    path: "/workspace",
    component: _21143642,
    name: "workspace"
  }, {
    path: "/applications/list",
    component: _02a18792,
    name: "applications-list"
  }, {
    path: "/auth/change-password",
    component: _5574c314,
    name: "auth-change-password"
  }, {
    path: "/auth/forgot-password",
    component: _aa3c6f78,
    name: "auth-forgot-password"
  }, {
    path: "/auth/forgot-password-application",
    component: _32a07bf2,
    name: "auth-forgot-password-application"
  }, {
    path: "/auth/login",
    component: _508e8236,
    name: "auth-login"
  }, {
    path: "/auth/login-application",
    component: _9ad6de30,
    name: "auth-login-application"
  }, {
    path: "/auth/register",
    component: _7bb5bd1a,
    name: "auth-register"
  }, {
    path: "/auth/register-application",
    component: _56bd25dd,
    name: "auth-register-application"
  }, {
    path: "/create/document",
    component: _70f5dc7e,
    name: "create-document"
  }, {
    path: "/create/first",
    component: _639d3a40,
    name: "create-first"
  }, {
    path: "/create/form",
    component: _4028b164,
    name: "create-form"
  }, {
    path: "/create/template",
    component: _7ab46d1d,
    name: "create-template"
  }, {
    path: "/document-templates/detail",
    component: _0c7ffff4,
    name: "document-templates-detail"
  }, {
    path: "/document/bulk-upload",
    component: _40f39764,
    name: "document-bulk-upload"
  }, {
    path: "/document/category",
    component: _7828ecc2,
    name: "document-category"
  }, {
    path: "/document/draft",
    component: _0fc18c5a,
    name: "document-draft"
  }, {
    path: "/document/search",
    component: _a0a908ee,
    name: "document-search"
  }, {
    path: "/document/shared",
    component: _636f946e,
    name: "document-shared"
  }, {
    path: "/document/upload",
    component: _68f1613c,
    name: "document-upload"
  }, {
    path: "/lp/allinone",
    component: _2ba36bb8,
    name: "lp-allinone"
  }, {
    path: "/lp/create",
    component: _610f4894,
    name: "lp-create"
  }, {
    path: "/lp/document",
    component: _340add9a,
    name: "lp-document"
  }, {
    path: "/lp/document2",
    component: _4d2182e2,
    name: "lp-document2"
  }, {
    path: "/lp/document3",
    component: _4d0553e0,
    name: "lp-document3"
  }, {
    path: "/lp/document4",
    component: _4ce924de,
    name: "lp-document4"
  }, {
    path: "/lp/document5",
    component: _4cccf5dc,
    name: "lp-document5"
  }, {
    path: "/lp/document6",
    component: _4cb0c6da,
    name: "lp-document6"
  }, {
    path: "/lp/document7",
    component: _4c9497d8,
    name: "lp-document7"
  }, {
    path: "/lp/document8",
    component: _4c7868d6,
    name: "lp-document8"
  }, {
    path: "/lp/speedy",
    component: _3682b5aa,
    name: "lp-speedy"
  }, {
    path: "/proposals/tag",
    component: _2b010bf9,
    name: "proposals-tag"
  }, {
    path: "/settings/calendar",
    component: _82db19cc,
    name: "settings-calendar"
  }, {
    path: "/settings/company",
    component: _17f07974,
    name: "settings-company"
  }, {
    path: "/settings/group",
    component: _461ed78e,
    name: "settings-group"
  }, {
    path: "/settings/notification",
    component: _e5bf1ef8,
    name: "settings-notification"
  }, {
    path: "/settings/payment",
    component: _4b24fb06,
    name: "settings-payment"
  }, {
    path: "/settings/plan",
    component: _934b967c,
    name: "settings-plan"
  }, {
    path: "/settings/plan-payment",
    component: _5597890a,
    name: "settings-plan-payment"
  }, {
    path: "/settings/plan-payment-success",
    component: _4a5440b1,
    name: "settings-plan-payment-success"
  }, {
    path: "/settings/plan-select-user",
    component: _236e7df1,
    name: "settings-plan-select-user"
  }, {
    path: "/settings/user",
    component: _5a6c1fe7,
    name: "settings-user"
  }, {
    path: "/templates/create",
    component: _a0a2ea16,
    name: "templates-create"
  }, {
    path: "/todo/create",
    component: _ecf0215c,
    name: "todo-create"
  }, {
    path: "/todo/template_detail",
    component: _6c7caf50,
    name: "todo-template_detail"
  }, {
    path: "/todo/template_first",
    component: _9af700fe,
    name: "todo-template_first"
  }, {
    path: "/todo/template_list",
    component: _1ae73246,
    name: "todo-template_list"
  }, {
    path: "/auth/register-application/confirm",
    component: _c119a7ea,
    name: "auth-register-application-confirm"
  }, {
    path: "/auth/register/confirm",
    component: _47d3488b,
    name: "auth-register-confirm"
  }, {
    path: "/create/document/edit",
    component: _600c81e4,
    name: "create-document-edit"
  }, {
    path: "/create/template/edit",
    component: _43e71e8f,
    name: "create-template-edit"
  }, {
    path: "/document/approve/list",
    component: _024ac541,
    name: "document-approve-list"
  }, {
    path: "/document/bulk-upload/list",
    component: _1461f45c,
    name: "document-bulk-upload-list"
  }, {
    path: "/settings/calendar/sync",
    component: _7c2de103,
    name: "settings-calendar-sync"
  }, {
    path: "/settings/group/ConfirmChangeRootUserModal",
    component: _7ca88279,
    name: "settings-group-ConfirmChangeRootUserModal"
  }, {
    path: "/settings/group/create",
    component: _2e5384b6,
    name: "settings-group-create"
  }, {
    path: "/settings/user/invite",
    component: _1098e744,
    name: "settings-user-invite"
  }, {
    path: "/document/bulk-upload/edit/:id",
    component: _9c3aa82e,
    name: "document-bulk-upload-edit-id"
  }, {
    path: "/settings/group/edit/:id?",
    component: _205a7fc4,
    name: "settings-group-edit-id"
  }, {
    path: "/settings/user/edit/:id?",
    component: _7bf66db0,
    name: "settings-user-edit-id"
  }, {
    path: "/applications/bank-transfer/:app_id?",
    component: _358bd09c,
    name: "applications-bank-transfer-app_id"
  }, {
    path: "/applications/detail/:id?",
    component: _1a94bed5,
    name: "applications-detail-id"
  }, {
    path: "/applications/form/:app_id?",
    component: _28817434,
    name: "applications-form-app_id"
  }, {
    path: "/auth/change-info/:active_code?",
    component: _1304e1df,
    name: "auth-change-info-active_code"
  }, {
    path: "/auth/forgot-password-application/:token?",
    component: _75101695,
    name: "auth-forgot-password-application-token"
  }, {
    path: "/auth/forgot-password/:token?",
    component: _371ed7f8,
    name: "auth-forgot-password-token"
  }, {
    path: "/auth/register/:token",
    component: _fe6d043c,
    name: "auth-register-token"
  }, {
    path: "/auth/verify-email-change-email/:token?",
    component: _01deedf9,
    name: "auth-verify-email-change-email-token"
  }, {
    path: "/auth/verify/:active_code?",
    component: _7111f3ce,
    name: "auth-verify-active_code"
  }, {
    path: "/document/approve/:token?",
    component: _73918cdd,
    name: "document-approve-token"
  }, {
    path: "/document/detail/:id",
    component: _6c436320,
    name: "document-detail-id"
  }, {
    path: "/document/draft/:id",
    component: _c870d60a,
    name: "document-draft-id"
  }, {
    path: "/document/edit/:id?",
    component: _aaa2fd54,
    name: "document-edit-id"
  }, {
    path: "/document/shared/:token",
    component: _fef3c9da,
    name: "document-shared-token"
  }, {
    path: "/ls-templates/detail/:id",
    component: _09ece385,
    name: "ls-templates-detail-id"
  }, {
    path: "/ls-templates/use/:id",
    component: _a3420f0e,
    name: "ls-templates-use-id"
  }, {
    path: "/proposals/clone/:key?",
    component: _a82fcffa,
    name: "proposals-clone-key"
  }, {
    path: "/proposals/detail/:id?",
    component: _55af5226,
    name: "proposals-detail-id"
  }, {
    path: "/proposals/edit/:id?",
    component: _6b91e5e6,
    name: "proposals-edit-id"
  }, {
    path: "/templates/clone/:key?",
    component: _00a72cea,
    name: "templates-clone-key"
  }, {
    path: "/templates/detail/:id?",
    component: _28eca875,
    name: "templates-detail-id"
  }, {
    path: "/templates/edit/:id?",
    component: _61ccf96e,
    name: "templates-edit-id"
  }, {
    path: "/templates/use/:id?",
    component: _1b4ed989,
    name: "templates-use-id"
  }, {
    path: "/todo/clone/:key?",
    component: _695b5130,
    name: "todo-clone-key"
  }, {
    path: "/todo/detail/:id?",
    component: _16dad35c,
    name: "todo-detail-id"
  }, {
    path: "/todo/edit/:id?",
    component: _2adeba8b,
    name: "todo-edit-id"
  }, {
    path: "/works/clone/:key?",
    component: _0024b3a2,
    name: "works-clone-key"
  }, {
    path: "/works/detail/:id?",
    component: _2964f28c,
    name: "works-detail-id"
  }, {
    path: "/works/use/:id?",
    component: _0e74c25c,
    name: "works-use-id"
  }, {
    path: "/document/detail/:id?/download",
    component: _31831aac,
    name: "document-detail-id-download"
  }, {
    path: "/document/checkback/:token?/:id?",
    component: _3341dae6,
    name: "document-checkback-token-id"
  }, {
    path: "/confirm-request/:hash?",
    component: _475426cd,
    name: "confirm-request-hash"
  }, {
    path: "/document-templates/:id",
    component: _5ead1ed5,
    name: "document-templates-id"
  }, {
    path: "/landing/:url?",
    component: _2107928b,
    name: "landing-url"
  }, {
    path: "/proposals/:month",
    component: _6741611c,
    name: "proposals-month"
  }, {
    path: "/todo/:status",
    component: _17284d2b,
    name: "todo-status"
  }, {
    path: "/admin",
    component: _be9dc5d0,
    name: "admin"
  }, {
    path: "/frontend",
    component: _528b1e7f,
    name: "frontend"
  }, {
    path: "/admin/application_categories",
    component: _61d6b950,
    name: "admin-application_categories"
  }, {
    path: "/admin/application_tags",
    component: _164da5d5,
    name: "admin-application_tags"
  }, {
    path: "/admin/application_view",
    component: _db5e253e,
    name: "admin-application_view"
  }, {
    path: "/admin/applications",
    component: _d77de6e0,
    name: "admin-applications"
  }, {
    path: "/admin/campaign-dashboard",
    component: _0aa4ab04,
    name: "admin-campaign-dashboard"
  }, {
    path: "/admin/campaign-statistics",
    component: _0d8b10c9,
    name: "admin-campaign-statistics"
  }, {
    path: "/admin/companies",
    component: _29b76c64,
    name: "admin-companies"
  }, {
    path: "/admin/contacts",
    component: _85773680,
    name: "admin-contacts"
  }, {
    path: "/admin/document-templates",
    component: _f01fd418,
    name: "admin-document-templates"
  }, {
    path: "/admin/landing-base",
    component: _04683d1e,
    name: "admin-landing-base"
  }, {
    path: "/admin/landings",
    component: _ec22832e,
    name: "admin-landings"
  }, {
    path: "/admin/meta-groups",
    component: _3f67ef36,
    name: "admin-meta-groups"
  }, {
    path: "/admin/metas",
    component: _0d9d58d7,
    name: "admin-metas"
  }, {
    path: "/admin/option-plan",
    component: _17ef75ec,
    name: "admin-option-plan"
  }, {
    path: "/admin/plans",
    component: _0ee7f59a,
    name: "admin-plans"
  }, {
    path: "/admin/project-list",
    component: _d4303102,
    name: "admin-project-list"
  }, {
    path: "/admin/proposals",
    component: _c100526c,
    name: "admin-proposals"
  }, {
    path: "/admin/request-confirm",
    component: _d575ee6a,
    name: "admin-request-confirm"
  }, {
    path: "/admin/request-ebooks",
    component: _4c360560,
    name: "admin-request-ebooks"
  }, {
    path: "/admin/revenue",
    component: _9ab9b636,
    name: "admin-revenue"
  }, {
    path: "/admin/settings",
    component: _13b53c90,
    name: "admin-settings"
  }, {
    path: "/admin/summary",
    component: _70c423ef,
    name: "admin-summary"
  }, {
    path: "/admin/tags",
    component: _66171206,
    name: "admin-tags"
  }, {
    path: "/admin/templates",
    component: _6fbe9f7c,
    name: "admin-templates"
  }, {
    path: "/admin/tool",
    component: _c6e49676,
    name: "admin-tool"
  }, {
    path: "/admin/types",
    component: _e6a906fc,
    name: "admin-types"
  }, {
    path: "/admin/users",
    component: _808f695e,
    name: "admin-users"
  }, {
    path: "/frontend/applications",
    component: _1aa66aee,
    name: "frontend-applications"
  }, {
    path: "/frontend/calendar",
    component: _39dd8f38,
    name: "frontend-calendar"
  }, {
    path: "/frontend/confirm-redirect",
    component: _09efa72c,
    name: "frontend-confirm-redirect"
  }, {
    path: "/frontend/contact",
    component: _64e3dce6,
    name: "frontend-contact"
  }, {
    path: "/frontend/contact-application",
    component: _0efb2790,
    name: "frontend-contact-application"
  }, {
    path: "/frontend/contact-complete",
    component: _027b2eae,
    name: "frontend-contact-complete"
  }, {
    path: "/frontend/contact-complete-application",
    component: _a08c96a8,
    name: "frontend-contact-complete-application"
  }, {
    path: "/frontend/dashboard",
    component: _da6bc67e,
    name: "frontend-dashboard"
  }, {
    path: "/frontend/document",
    component: _5af71e01,
    name: "frontend-document"
  }, {
    path: "/frontend/document-templates",
    component: _d06c95a6,
    name: "frontend-document-templates"
  }, {
    path: "/frontend/function",
    component: _e3daeb8a,
    name: "frontend-function"
  }, {
    path: "/frontend/group-chats",
    component: _1ec19286,
    name: "frontend-group-chats"
  }, {
    path: "/frontend/ls-templates",
    component: _7f9c77d9,
    name: "frontend-ls-templates"
  }, {
    path: "/frontend/privacy",
    component: _24ba1cf5,
    name: "frontend-privacy"
  }, {
    path: "/frontend/privacy-application",
    component: _eaad5210,
    name: "frontend-privacy-application"
  }, {
    path: "/frontend/proposals",
    component: _15908371,
    name: "frontend-proposals"
  }, {
    path: "/frontend/receipt",
    component: _158b0a68,
    name: "frontend-receipt"
  }, {
    path: "/frontend/request-group",
    component: _699a96ee,
    name: "frontend-request-group"
  }, {
    path: "/frontend/resources",
    component: _1034805c,
    name: "frontend-resources"
  }, {
    path: "/frontend/resources-complete",
    component: _48f9f804,
    name: "frontend-resources-complete"
  }, {
    path: "/frontend/settings",
    component: _6a18df09,
    name: "frontend-settings"
  }, {
    path: "/frontend/templates",
    component: _3e315ce9,
    name: "frontend-templates"
  }, {
    path: "/frontend/terms",
    component: _06ee4698,
    name: "frontend-terms"
  }, {
    path: "/frontend/terms-application",
    component: _59d91f92,
    name: "frontend-terms-application"
  }, {
    path: "/frontend/todo",
    component: _5cc90e28,
    name: "frontend-todo"
  }, {
    path: "/frontend/trade",
    component: _a0e563de,
    name: "frontend-trade"
  }, {
    path: "/frontend/trade-application",
    component: _c8e083d8,
    name: "frontend-trade-application"
  }, {
    path: "/frontend/works",
    component: _67fae072,
    name: "frontend-works"
  }, {
    path: "/frontend/workspace",
    component: _21143642,
    name: "frontend-workspace"
  }, {
    path: "/admin/application_categories/create",
    component: _3b341266,
    name: "admin-application_categories-create"
  }, {
    path: "/admin/application_tags/create",
    component: _49c940ee,
    name: "admin-application_tags-create"
  }, {
    path: "/admin/applications/create",
    component: _1b94d02e,
    name: "admin-applications-create"
  }, {
    path: "/admin/auth/login",
    component: _0cb6f7ec,
    name: "admin-auth-login"
  }, {
    path: "/admin/companies/create",
    component: _34ea6ada,
    name: "admin-companies-create"
  }, {
    path: "/admin/document-templates/create",
    component: _c472196c,
    name: "admin-document-templates-create"
  }, {
    path: "/admin/document/categories",
    component: _0f04bb4e,
    name: "admin-document-categories"
  }, {
    path: "/admin/landings/create",
    component: _48c54d16,
    name: "admin-landings-create"
  }, {
    path: "/admin/meta-groups/create",
    component: _50e94ef9,
    name: "admin-meta-groups-create"
  }, {
    path: "/admin/metas/create",
    component: _647be672,
    name: "admin-metas-create"
  }, {
    path: "/admin/plans/create",
    component: _40a8ebeb,
    name: "admin-plans-create"
  }, {
    path: "/admin/proposals/create",
    component: _782f4d34,
    name: "admin-proposals-create"
  }, {
    path: "/admin/settings/calendar",
    component: _b56d451a,
    name: "admin-settings-calendar"
  }, {
    path: "/admin/tags/create",
    component: _f7010d10,
    name: "admin-tags-create"
  }, {
    path: "/admin/templates/create",
    component: _63a9a2bc,
    name: "admin-templates-create"
  }, {
    path: "/admin/types/create",
    component: _30785e7c,
    name: "admin-types-create"
  }, {
    path: "/frontend/applications/list",
    component: _02a18792,
    name: "frontend-applications-list"
  }, {
    path: "/frontend/auth/change-password",
    component: _5574c314,
    name: "frontend-auth-change-password"
  }, {
    path: "/frontend/auth/forgot-password",
    component: _aa3c6f78,
    name: "frontend-auth-forgot-password"
  }, {
    path: "/frontend/auth/forgot-password-application",
    component: _32a07bf2,
    name: "frontend-auth-forgot-password-application"
  }, {
    path: "/frontend/auth/login",
    component: _508e8236,
    name: "frontend-auth-login"
  }, {
    path: "/frontend/auth/login-application",
    component: _9ad6de30,
    name: "frontend-auth-login-application"
  }, {
    path: "/frontend/auth/register",
    component: _7bb5bd1a,
    name: "frontend-auth-register"
  }, {
    path: "/frontend/auth/register-application",
    component: _56bd25dd,
    name: "frontend-auth-register-application"
  }, {
    path: "/frontend/create/document",
    component: _70f5dc7e,
    name: "frontend-create-document"
  }, {
    path: "/frontend/create/first",
    component: _639d3a40,
    name: "frontend-create-first"
  }, {
    path: "/frontend/create/form",
    component: _4028b164,
    name: "frontend-create-form"
  }, {
    path: "/frontend/create/template",
    component: _7ab46d1d,
    name: "frontend-create-template"
  }, {
    path: "/frontend/document-templates/detail",
    component: _0c7ffff4,
    name: "frontend-document-templates-detail"
  }, {
    path: "/frontend/document/bulk-upload",
    component: _40f39764,
    name: "frontend-document-bulk-upload"
  }, {
    path: "/frontend/document/category",
    component: _7828ecc2,
    name: "frontend-document-category"
  }, {
    path: "/frontend/document/draft",
    component: _0fc18c5a,
    name: "frontend-document-draft"
  }, {
    path: "/frontend/document/search",
    component: _a0a908ee,
    name: "frontend-document-search"
  }, {
    path: "/frontend/document/shared",
    component: _636f946e,
    name: "frontend-document-shared"
  }, {
    path: "/frontend/document/upload",
    component: _68f1613c,
    name: "frontend-document-upload"
  }, {
    path: "/frontend/lp/allinone",
    component: _2ba36bb8,
    name: "frontend-lp-allinone"
  }, {
    path: "/frontend/lp/create",
    component: _610f4894,
    name: "frontend-lp-create"
  }, {
    path: "/frontend/lp/document",
    component: _340add9a,
    name: "frontend-lp-document"
  }, {
    path: "/frontend/lp/document2",
    component: _4d2182e2,
    name: "frontend-lp-document2"
  }, {
    path: "/frontend/lp/document3",
    component: _4d0553e0,
    name: "frontend-lp-document3"
  }, {
    path: "/frontend/lp/document4",
    component: _4ce924de,
    name: "frontend-lp-document4"
  }, {
    path: "/frontend/lp/document5",
    component: _4cccf5dc,
    name: "frontend-lp-document5"
  }, {
    path: "/frontend/lp/document6",
    component: _4cb0c6da,
    name: "frontend-lp-document6"
  }, {
    path: "/frontend/lp/document7",
    component: _4c9497d8,
    name: "frontend-lp-document7"
  }, {
    path: "/frontend/lp/document8",
    component: _4c7868d6,
    name: "frontend-lp-document8"
  }, {
    path: "/frontend/lp/speedy",
    component: _3682b5aa,
    name: "frontend-lp-speedy"
  }, {
    path: "/frontend/proposals/tag",
    component: _2b010bf9,
    name: "frontend-proposals-tag"
  }, {
    path: "/frontend/settings/calendar",
    component: _82db19cc,
    name: "frontend-settings-calendar"
  }, {
    path: "/frontend/settings/company",
    component: _17f07974,
    name: "frontend-settings-company"
  }, {
    path: "/frontend/settings/group",
    component: _461ed78e,
    name: "frontend-settings-group"
  }, {
    path: "/frontend/settings/notification",
    component: _e5bf1ef8,
    name: "frontend-settings-notification"
  }, {
    path: "/frontend/settings/payment",
    component: _4b24fb06,
    name: "frontend-settings-payment"
  }, {
    path: "/frontend/settings/plan",
    component: _934b967c,
    name: "frontend-settings-plan"
  }, {
    path: "/frontend/settings/plan-payment",
    component: _5597890a,
    name: "frontend-settings-plan-payment"
  }, {
    path: "/frontend/settings/plan-payment-success",
    component: _4a5440b1,
    name: "frontend-settings-plan-payment-success"
  }, {
    path: "/frontend/settings/plan-select-user",
    component: _236e7df1,
    name: "frontend-settings-plan-select-user"
  }, {
    path: "/frontend/settings/user",
    component: _5a6c1fe7,
    name: "frontend-settings-user"
  }, {
    path: "/frontend/templates/create",
    component: _a0a2ea16,
    name: "frontend-templates-create"
  }, {
    path: "/frontend/todo/create",
    component: _ecf0215c,
    name: "frontend-todo-create"
  }, {
    path: "/frontend/todo/template_detail",
    component: _6c7caf50,
    name: "frontend-todo-template_detail"
  }, {
    path: "/frontend/todo/template_first",
    component: _9af700fe,
    name: "frontend-todo-template_first"
  }, {
    path: "/frontend/todo/template_list",
    component: _1ae73246,
    name: "frontend-todo-template_list"
  }, {
    path: "/admin/document/categories/create",
    component: _3eeaf385,
    name: "admin-document-categories-create"
  }, {
    path: "/admin/settings/calendar/oauth2callback",
    component: _eabfa922,
    name: "admin-settings-calendar-oauth2callback"
  }, {
    path: "/frontend/auth/register-application/confirm",
    component: _c119a7ea,
    name: "frontend-auth-register-application-confirm"
  }, {
    path: "/frontend/auth/register/confirm",
    component: _47d3488b,
    name: "frontend-auth-register-confirm"
  }, {
    path: "/frontend/create/document/edit",
    component: _600c81e4,
    name: "frontend-create-document-edit"
  }, {
    path: "/frontend/create/template/edit",
    component: _43e71e8f,
    name: "frontend-create-template-edit"
  }, {
    path: "/frontend/document/approve/list",
    component: _024ac541,
    name: "frontend-document-approve-list"
  }, {
    path: "/frontend/document/bulk-upload/list",
    component: _1461f45c,
    name: "frontend-document-bulk-upload-list"
  }, {
    path: "/frontend/settings/calendar/sync",
    component: _7c2de103,
    name: "frontend-settings-calendar-sync"
  }, {
    path: "/frontend/settings/group/ConfirmChangeRootUserModal",
    component: _7ca88279,
    name: "frontend-settings-group-ConfirmChangeRootUserModal"
  }, {
    path: "/frontend/settings/group/create",
    component: _2e5384b6,
    name: "frontend-settings-group-create"
  }, {
    path: "/frontend/settings/user/invite",
    component: _1098e744,
    name: "frontend-settings-user-invite"
  }, {
    path: "/admin/document/categories/edit/:id?",
    component: _13917dfe,
    name: "admin-document-categories-edit-id"
  }, {
    path: "/frontend/document/bulk-upload/edit/:id",
    component: _9c3aa82e,
    name: "frontend-document-bulk-upload-edit-id"
  }, {
    path: "/frontend/settings/group/edit/:id?",
    component: _205a7fc4,
    name: "frontend-settings-group-edit-id"
  }, {
    path: "/frontend/settings/user/edit/:id?",
    component: _7bf66db0,
    name: "frontend-settings-user-edit-id"
  }, {
    path: "/admin/application_categories/edit/:id?",
    component: _220e689f,
    name: "admin-application_categories-edit-id"
  }, {
    path: "/admin/application_tags/edit/:id?",
    component: _6556f902,
    name: "admin-application_tags-edit-id"
  }, {
    path: "/admin/applications/build/:id?",
    component: _fe205852,
    name: "admin-applications-build-id"
  }, {
    path: "/admin/applications/edit/:id?",
    component: _6d36d467,
    name: "admin-applications-edit-id"
  }, {
    path: "/admin/companies/edit/:id?",
    component: _f0df17da,
    name: "admin-companies-edit-id"
  }, {
    path: "/admin/document-templates/edit/:id",
    component: _2b6ca083,
    name: "admin-document-templates-edit-id"
  }, {
    path: "/admin/document/categories/:id",
    component: _63926701,
    name: "admin-document-categories-id"
  }, {
    path: "/admin/landings/copy/:target_id?",
    component: _eb90b48a,
    name: "admin-landings-copy-target_id"
  }, {
    path: "/admin/landings/edit/:id?",
    component: _4d4227ee,
    name: "admin-landings-edit-id"
  }, {
    path: "/admin/meta-groups/edit/:id",
    component: _c132671c,
    name: "admin-meta-groups-edit-id"
  }, {
    path: "/admin/metas/edit/:id?",
    component: _49074ec0,
    name: "admin-metas-edit-id"
  }, {
    path: "/admin/plans/edit/:id?",
    component: _c49a1638,
    name: "admin-plans-edit-id"
  }, {
    path: "/admin/plans/new/:id?",
    component: _afa95b28,
    name: "admin-plans-new-id"
  }, {
    path: "/admin/proposals/edit/:id?",
    component: _0d2627ed,
    name: "admin-proposals-edit-id"
  }, {
    path: "/admin/tags/edit/:id?",
    component: _461c5331,
    name: "admin-tags-edit-id"
  }, {
    path: "/admin/templates/edit/:id?",
    component: _03613b75,
    name: "admin-templates-edit-id"
  }, {
    path: "/admin/types/edit/:id?",
    component: _511ff196,
    name: "admin-types-edit-id"
  }, {
    path: "/frontend/applications/bank-transfer/:app_id?",
    component: _358bd09c,
    name: "frontend-applications-bank-transfer-app_id"
  }, {
    path: "/frontend/applications/detail/:id?",
    component: _1a94bed5,
    name: "frontend-applications-detail-id"
  }, {
    path: "/frontend/applications/form/:app_id?",
    component: _28817434,
    name: "frontend-applications-form-app_id"
  }, {
    path: "/frontend/auth/change-info/:active_code?",
    component: _1304e1df,
    name: "frontend-auth-change-info-active_code"
  }, {
    path: "/frontend/auth/forgot-password-application/:token?",
    component: _75101695,
    name: "frontend-auth-forgot-password-application-token"
  }, {
    path: "/frontend/auth/forgot-password/:token?",
    component: _371ed7f8,
    name: "frontend-auth-forgot-password-token"
  }, {
    path: "/frontend/auth/register/:token",
    component: _fe6d043c,
    name: "frontend-auth-register-token"
  }, {
    path: "/frontend/auth/verify-email-change-email/:token?",
    component: _01deedf9,
    name: "frontend-auth-verify-email-change-email-token"
  }, {
    path: "/frontend/auth/verify/:active_code?",
    component: _7111f3ce,
    name: "frontend-auth-verify-active_code"
  }, {
    path: "/frontend/document/approve/:token?",
    component: _73918cdd,
    name: "frontend-document-approve-token"
  }, {
    path: "/frontend/document/detail/:id",
    component: _6c436320,
    name: "frontend-document-detail-id"
  }, {
    path: "/frontend/document/draft/:id",
    component: _c870d60a,
    name: "frontend-document-draft-id"
  }, {
    path: "/frontend/document/edit/:id?",
    component: _aaa2fd54,
    name: "frontend-document-edit-id"
  }, {
    path: "/frontend/document/shared/:token",
    component: _fef3c9da,
    name: "frontend-document-shared-token"
  }, {
    path: "/frontend/ls-templates/detail/:id",
    component: _09ece385,
    name: "frontend-ls-templates-detail-id"
  }, {
    path: "/frontend/ls-templates/use/:id",
    component: _a3420f0e,
    name: "frontend-ls-templates-use-id"
  }, {
    path: "/frontend/proposals/clone/:key?",
    component: _a82fcffa,
    name: "frontend-proposals-clone-key"
  }, {
    path: "/frontend/proposals/detail/:id?",
    component: _55af5226,
    name: "frontend-proposals-detail-id"
  }, {
    path: "/frontend/proposals/edit/:id?",
    component: _6b91e5e6,
    name: "frontend-proposals-edit-id"
  }, {
    path: "/frontend/templates/clone/:key?",
    component: _00a72cea,
    name: "frontend-templates-clone-key"
  }, {
    path: "/frontend/templates/detail/:id?",
    component: _28eca875,
    name: "frontend-templates-detail-id"
  }, {
    path: "/frontend/templates/edit/:id?",
    component: _61ccf96e,
    name: "frontend-templates-edit-id"
  }, {
    path: "/frontend/templates/use/:id?",
    component: _1b4ed989,
    name: "frontend-templates-use-id"
  }, {
    path: "/frontend/todo/clone/:key?",
    component: _695b5130,
    name: "frontend-todo-clone-key"
  }, {
    path: "/frontend/todo/detail/:id?",
    component: _16dad35c,
    name: "frontend-todo-detail-id"
  }, {
    path: "/frontend/todo/edit/:id?",
    component: _2adeba8b,
    name: "frontend-todo-edit-id"
  }, {
    path: "/frontend/works/clone/:key?",
    component: _0024b3a2,
    name: "frontend-works-clone-key"
  }, {
    path: "/frontend/works/detail/:id?",
    component: _2964f28c,
    name: "frontend-works-detail-id"
  }, {
    path: "/frontend/works/use/:id?",
    component: _0e74c25c,
    name: "frontend-works-use-id"
  }, {
    path: "/frontend/document/detail/:id?/download",
    component: _31831aac,
    name: "frontend-document-detail-id-download"
  }, {
    path: "/frontend/document/checkback/:token?/:id?",
    component: _3341dae6,
    name: "frontend-document-checkback-token-id"
  }, {
    path: "/admin/application_categories/:id",
    component: _79a39bc0,
    name: "admin-application_categories-id"
  }, {
    path: "/admin/application_tags/:id",
    component: _b975cd06,
    name: "admin-application_tags-id"
  }, {
    path: "/admin/companies/:id",
    component: _143d37cc,
    name: "admin-companies-id"
  }, {
    path: "/admin/contacts/:id",
    component: _04249728,
    name: "admin-contacts-id"
  }, {
    path: "/admin/document-templates/:id?",
    component: _8e99f548,
    name: "admin-document-templates-id"
  }, {
    path: "/admin/metas/:id",
    component: _1989a4ff,
    name: "admin-metas-id"
  }, {
    path: "/admin/option-plan/:id?",
    component: _2bcffc1c,
    name: "admin-option-plan-id"
  }, {
    path: "/admin/plans/:id",
    component: _75afb85b,
    name: "admin-plans-id"
  }, {
    path: "/admin/project-list/:id?",
    component: _761084b2,
    name: "admin-project-list-id"
  }, {
    path: "/admin/proposals/:id",
    component: _846df89c,
    name: "admin-proposals-id"
  }, {
    path: "/admin/tags/:id",
    component: _0a2dddee,
    name: "admin-tags-id"
  }, {
    path: "/admin/users/:id",
    component: _78d2edf9,
    name: "admin-users-id"
  }, {
    path: "/frontend/confirm-request/:hash?",
    component: _475426cd,
    name: "frontend-confirm-request-hash"
  }, {
    path: "/frontend/document-templates/:id",
    component: _5ead1ed5,
    name: "frontend-document-templates-id"
  }, {
    path: "/frontend/landing/:url?",
    component: _2107928b,
    name: "frontend-landing-url"
  }, {
    path: "/frontend/proposals/:month",
    component: _6741611c,
    name: "frontend-proposals-month"
  }, {
    path: "/frontend/todo/:status",
    component: _17284d2b,
    name: "frontend-todo-status"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
